import { render, staticRenderFns } from "./nutritional-information.vue?vue&type=template&id=3da2fa1a&"
import script from "./nutritional-information.vue?vue&type=script&lang=js&"
export * from "./nutritional-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports